angular.module('impactx.landingpage').controller('ApprovalWorkflowCtrl', [
    'dataGen',
    '$redirect',
    '$routeParams',
    ApprovalWorkflowController
]);

function ApprovalWorkflowController(dataGen, $redirect, $routeParams) {
    var self = this;
    self.prhId = $routeParams.prhId;

    (self.init = function () {
        if (self.prhId > 0) {
            getWorkflow();
        }
        else {
            redirectToStatusList();
        }
    })();

    self.redirectToRequestList = function () {
        redirectToStatusList();
    };

    function getWorkflow() {
        return dataGen.getData(self, {prhId: self.prhId}, '/landingpage/approvalworkflow');
    }

    function redirectToStatusList() {
        $redirect.redirectTo(null, '/purchaserequestlist');
    }
}